import { Board, List } from "../../freelo";
import { IConverter, TSnapshot } from "../generics";

export const listConverter: IConverter<List> = {
  toFirestore(list: Omit<List, "id">) {
    return {
      name: list.name,
      order: list.order,
      cardOrder: list.cardOrder,
      color: list.color,
      createdAt: list.createdAt,
      updatedAt: list.updatedAt,
    };
  },
  fromFirestore(snapshot: TSnapshot) {
    const data = snapshot.data() as List;
    return {
      id: snapshot.id,
      name: data?.name,
      order: data?.order,
      cardOrder: data?.cardOrder,
      color: data?.color,
      createdAt: data?.createdAt,
      updatedAt: data?.updatedAt,
    };
  },
};
